import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { NumericAdapter } from "../NumericAdapter";

import { ColumnDefinition } from "../../model/ColumnDefinition";

import { ICcyLookupService } from "../../lookup/model/ICcyLookupService";

export class AmtAdapter extends NumericAdapter {
  protected myCcyLookup: ICcyLookupService;

  constructor(ccyLookup: ICcyLookupService) {
    super();
    this.myCcyLookup = ccyLookup;
  }

  getCcyCode(order: any): string {
    throw "must be overwritten";
  }

  getValue(order: any, columnProperty: string): any {
    return order[columnProperty];
  }

  retrieveData(order: any, columnProperty: string): string {
    if (
      order.requestedOrderType == CubiqTS.RequestOrderType.CALL ||
      order.requestOrderType == CubiqTS.RequestOrderType.CALL
    )
      return "-";

    if (this.myCcyLookup) {
      let value: any = this.getValue(order, columnProperty);
      if (value == undefined || value == null) return "-";

      let bigNum: CubiqTS.BigNumber = new CubiqTS.BigNumber(value);
      return bigNum.toFormat(0);
    }

    return String(order[columnProperty]);
  }
  retrieveSort(order: any, columnProperty: string): any {
    if (
      order.requestedOrderType == CubiqTS.RequestOrderType.CALL ||
      order.requestOrderType == CubiqTS.RequestOrderType.CALL
    )
      return "";
    let value: any = this.getValue(order, columnProperty);
    if (value != null && value != undefined) {
      return new CubiqTS.BigNumber(value).toString();
    }
    return "0";
  }

  retrieveSearch(order: any, columnProperty: string): any {
    if (
      order.requestedOrderType == CubiqTS.RequestOrderType.CALL ||
      order.requestOrderType == CubiqTS.RequestOrderType.CALL
    )
      return "";

    let value: any = this.getValue(order, columnProperty);
    var precision: number = 0;
    if (value != null && value != undefined) {
      if (this.myCcyLookup) {
        var ccy = this.myCcyLookup.getCcy(this.getCcyCode(order));
        if (ccy) {
          precision = ccy.minorUnitsQty.toNumber();
        }
      }
      return new CubiqTS.BigNumber(value).toFixed(0);
    }

    return "0";
  }

  retrieveDetails(order: any, columnProperty: string): any {
    if (
      order.requestedOrderType == CubiqTS.RequestOrderType.CALL ||
      order.requestOrderType == CubiqTS.RequestOrderType.CALL
    )
      return "-";

    let value: any = this.getValue(order, columnProperty);
    var precision: number = 0;
    if (value != null && value != undefined) {
      let bigNum: CubiqTS.BigNumber = new CubiqTS.BigNumber(value);
      if (this.myCcyLookup) {
        var ccy = this.myCcyLookup.getCcy(this.getCcyCode(order));
        if (ccy && bigNum.decimalPlaces() != 0) {
          precision = ccy.minorUnitsQty.toNumber();
        }
      }
      return bigNum.toFormat(precision);
    }

    return "-";
  }

  retrieveFilter(order: any, columnProperty: string): string {
    return this.getValue(order, columnProperty);
  }
}
